import { createTheme } from "@mui/material/styles";

export const buildMuiTheme = (tokens = {}) => {
  const colors = tokens.colors || {};
  const typography = tokens.typography || {};
  const components = tokens.components || {};

  return createTheme({
    palette: {
      primary: {
        main: colors.primary || "#277777",
      },
      secondary: {
        main: colors.secondary || "#505355",
      },
      background: {
        default: colors.background || "#ffffff",
        secondary: colors.background?.secondary || "#f5f5f5",
      },
      text: {
        primary: colors.text?.primary || "#1A1A1A",
        secondary: colors.text?.secondary || "#6B7280",
        disabled: colors.text?.disabled || "#9CA3AF",
      },
      border: {
        default: colors.border?.default || "#3c3c3c",
        hover: colors.border?.hover || "#3c3c3c",
        active: colors.border?.active || "#3c3c3c",
      },
    },

    typography: {
      fontFamily: typography.fontFamily || "Inter, sans-serif",

      h1: {
        fontWeight: typography.headingWeight || 600,
      },
      h2: {
        fontWeight: typography.headingWeight || 600,
      },
      h3: {
        fontWeight: typography.headingWeight || 600,
      },
      h5: {
        fontWeight: typography.headingWeight || 600,
      },

      body1: {
        fontWeight: typography.bodyWeight || 400,
        fontSize: typography.body1?.fontSize || "16px",
      },
      body2: {
        fontWeight: typography.bodyWeight || 400,
      },
    },

    shape: {
      borderRadius: components?.button?.borderRadius ? parseInt(components.button.borderRadius) : 4,
    },

    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: components?.button?.borderRadius || "4px",
            padding: components?.button?.padding || "6px 16px",
            textTransform: "none",
          },
          containedPrimary: {
            backgroundColor: colors.primary || "#277777",
            "&:hover": {
              backgroundColor: colors.hover || "#005962",
            },
          },
        },
      },
      border: {
        default: components?.border?.default || "1px",
        hover: components?.border?.hover || "1px",
        active: components?.border?.active || "2px",
      },
    },
  });
};
